module.exports = __webpack_public_path__ + "img/dollarSign.de738d2b.svg";